import { render, staticRenderFns } from "./SpecialTask.vue?vue&type=template&id=81000276&scoped=true&lang=pug&"
import script from "./SpecialTask.vue?vue&type=script&lang=js&"
export * from "./SpecialTask.vue?vue&type=script&lang=js&"
import style0 from "./SpecialTask.vue?vue&type=style&index=0&id=81000276&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81000276",
  null
  
)

export default component.exports